
const sortByWdAsc = (a: any, b: any) => {
  if (a && a.wd) {
    if (b && b.wd) {
      if (a.wd < b.wd) {
        return -1
      }
      if (a.wd > b.wd) {
        return 1;
      }
      return 0;
    }
    return -1;
  }
  if (b) {
    return 1;
  }
  return 0;
};

const sortByIdAsc = (a: any, b: any) => {

  if (a && a.id) {
    if (b && b.id) {
      if (a.id < b.id) {
        return -1
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    }
    return -1;
  }
  if (b) {
    return 1;
  }
  return 0;
};

const sortingFunctions: any = {
  1: (a: any, b: any) => {

    if (a && a.wd) {
      if (b && b.wd) {
        if (a.wd > b.wd) {
          return -1
        }
        if (a.wd < b.wd) {
          return 1;
        }
        return (a.id > b.id) ? -1 : (a.id < b.id ? 1 : 0);
      }
      return -1;
    }
    if (b) {
      return 1;
    }
    return 0;
  },
  2: (a: any, b: any) => {

    if (a && a.wd) {
      if (b && b.wd) {
        if (a.wd > b.wd) {
          return 1
        }
        if (a.wd < b.wd) {
          return -1;
        }
        return (a.id > b.id) ? 1 : (a.id < b.id ? -1 : 0);
      }
      return 1;
    }
    if (b) {
      return -1;
    }
    return 0;
  },
  3: (a: any, b: any) => {
    return sortByWdAsc(a, b) * -1;
  },
  4: sortByWdAsc,
  5: (a: any, b: any) => {
    return sortByIdAsc(a, b) * -1;
  },
  6: sortByIdAsc
};

export function getSortFunction(id: any) {
  return id && sortingFunctions[id] ? sortingFunctions[id] : null;
}

export function getSortTypes() {
  return [
    {
      id: 1,
      label: 'Leistungdatum und ID absteigend',
      dir: 'desc'
    },
    {
      id: 2,
      label: 'Leistungdatum und ID aufsteigend',
      dir: 'asc'
    },
    {
      id: 3,
      label: 'Leistungdatum absteigend',
      dir: 'desc'
    },
    {
      id: 4,
      label: 'Leistungdatum aufsteigend',
      dir: 'asc'
    },
    {
      id: 5,
      label: 'ID absteigend',
      dir: 'desc'
    },
    {
      id: 6,
      label: 'ID aufsteigend',
      dir: 'asc'
    },
  ];
}
